/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Humboldtschule1Inputs */

const en__field_enum_humboldtschule1 = /** @type {(inputs: _Field_Enum_Humboldtschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad Homburg`)
};

const de__field_enum_humboldtschule1 = /** @type {(inputs: _Field_Enum_Humboldtschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Humboldtschule`)
};

/**
* | output |
* | --- |
* | "Bad Homburg" |
*
* @param {_Field_Enum_Humboldtschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_humboldtschule1 = /** @type {((inputs?: _Field_Enum_Humboldtschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Humboldtschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_humboldtschule1(inputs)
	return de__field_enum_humboldtschule1(inputs)
});
export { _field_enum_humboldtschule1 as "_field_enum_Humboldtschule" }